import { useSelector } from 'react-redux';
import { getProjectEntitlement } from '../../../project/selectors.js';
import type { ProjectSlice } from '../../../project/types.js';
import { getDefaultLocaleInitialData, getLocalesState, getLocalesTableData } from '../../selectors.js';
import type { LocalesHookProps } from './locales.js';

export const useLocales = (): LocalesHookProps => {
  const localesEntitlement = useSelector((state: ProjectSlice) =>
    getProjectEntitlement(state, { entitlement: 'locales' })
  ) as number;
  const localesState = useSelector(getLocalesState);
  const isSaving = localesState.get('saving');
  const locales = useSelector(getLocalesTableData);
  const defaultLocaleInitialData = useSelector(getDefaultLocaleInitialData);

  return { localesEntitlement, isSaving, locales, defaultLocaleInitialData };
};
